import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SkipLink } from '@digdir/designsystemet-react';
import cn from 'classnames';
import classes from './PublicPageLayout.module.css';
import { TrustpulseLogo } from '../TrustpulseLogo';

interface PublicPageLayoutProps {
  children: ReactNode;
  /** Vises til høyre i topplinjen, for eksempel språkvalg */
  headerActions?: ReactNode;
  footer?: ReactNode;
  /** Innholdet styrer selv bakgrunn og bredde */
  fullBleed?: boolean;
}

export const PublicPageLayout = ({
  children,
  headerActions,
  footer,
  fullBleed = false,
}: PublicPageLayoutProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn(classes.container, { [classes.fullBleed]: fullBleed })}>
      <SkipLink href="#main">{t('sidebar.skipToContent')}</SkipLink>
      <header className={classes.header}>
        <div className={classes.headerInner}>
          <TrustpulseLogo />
          {headerActions}
        </div>
      </header>
      <main id="main" tabIndex={-1} className={classes.content}>
        {children}
      </main>
      {footer}
    </div>
  );
};
